
import React from 'react';

import NonFSIndex from "@dndComponents/NonFSIndex";

export default function RollableTableIndex() {
  return (
    <NonFSIndex
      data_type="rollable_table"
    />
  );
}
